import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "goal-image-wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "no-image-placeholder rounded",
  style: {"width":"70px","height":"70px"}
}
const _hoisted_6 = { class: "goal-content" }
const _hoisted_7 = { class: "goal-text" }
const _hoisted_8 = { class: "goal-title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "goal-progress-row" }
const _hoisted_11 = { class: "progress-wrapper" }
const _hoisted_12 = { class: "progress-text" }

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import UserGoal from '../../../api/v2/models/user_goal'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { debounce } from 'underscore'
import { footerState } from '../../stores/footer'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGoalList',
  setup(__props) {

const router = useRouter()

// Reactive Data
const mobile = ref(false)
const search = ref('')
const userGoals = ref<UserGoal[]>([])

// Functions
const handleSearch = debounce(async (searchValue: string) => {
  userGoals.value = await api.userGoal.index({ search: searchValue }).catch(() => [])
}, 400)

function goToDetail(userGoal: UserGoal) {
  router.push(`/classroom/user-goals/${userGoal.id}`)
}

// Watchers
watch(search, (newValue) => {
  handleSearch(newValue)
})

// Created logic
;(async () => {
  headerState.setTitle('ゴール一覧')
  footerState.setFooterDefault()
  userGoals.value = await api.userGoal.index().catch(() => [])
})()

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'ゴール一覧' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "12",
        cols: "12",
        class: "pt-0 bg-white"
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" Search bar row "),
          _createVNode(_component_v_row, {
            class: "align-center px-3 py-2",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "8",
                md: "9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                    placeholder: "ゴール名を入力してください",
                    "prepend-inner-icon": "mdi-magnify",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    clearable: ""
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                md: "3",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "outlined",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (search.value = ''))
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("クリア", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userGoals.value, (userGoal) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: userGoal.id
            }, [
              _createElementVNode("div", {
                class: "user-goal-item pa-3",
                onClick: ($event: any) => (goToDetail(userGoal))
              }, [
                _createCommentVNode(" Image "),
                _createElementVNode("div", _hoisted_4, [
                  (userGoal.goal?.image?.url)
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        width: "70",
                        height: "70",
                        src: userGoal.goal.image.url,
                        class: "rounded",
                        cover: ""
                      }, null, 8 /* PROPS */, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_v_icon, {
                          size: "large",
                          color: "grey"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-image-off", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]))
                ]),
                _createCommentVNode(" Content "),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(userGoal.goal.name), 1 /* TEXT */),
                    _createElementVNode("div", {
                      class: "goal-description",
                      innerHTML: userGoal.goal.description
                    }, null, 8 /* PROPS */, _hoisted_9)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": userGoal.progressRate,
                        height: "20",
                        color: "primary",
                        rounded: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(userGoal.progressRate) + "%", 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value"])
                    ])
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_3),
              _createVNode(_component_v_divider)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})